import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const CareTeamPage = () => {
  const { activeCareProfile } = useAuth();

  if (!activeCareProfile) {
    return <Navigate to="/profiles" replace />;
  }

  return (
    <Navigate
      to={`/profiles/view/${activeCareProfile.id}#family-circle`}
      replace
    />
  );
};

export default CareTeamPage;
